import React from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import i18n from "../../../../utils/i18n";

export const MotorContact = ({ user, setUser }) => (
  <>
    <FloatingLabel controlId="motor-name" label="Your name*">
      <Form.Control type="text" placeholder="Your name*" required value={user.name}
        onChange={(event) => setUser((previous) => ({ ...previous, name: event.target.value }))} />
    </FloatingLabel>
    <FloatingLabel controlId="motor-mobile" label={`${i18n.t("Your Mobile Number")}*`}>
      <Form.Control type="tel" inputMode="numeric" pattern="[0-9]{10}" required
        placeholder={`${i18n.t("Your Mobile Number")}*`} value={user.phone}
        onChange={(event) => setUser((previous) => ({ ...previous, phone: event.target.value }))} />
    </FloatingLabel>
    <FloatingLabel controlId="motor-email" label={`${i18n.t("Your Email")}*`}>
      <Form.Control type="email" placeholder={`${i18n.t("Your Email")}*`} required
        value={user.email}
        onChange={(event) => setUser((previous) => ({ ...previous, email: event.target.value }))} />
    </FloatingLabel>
  </>
);

export const MotorVehicleType = ({ details, setDetails }) => (
  <FloatingLabel controlId="motor-vehicle-type" label="Vehicle type*" className="has-content">
    <Form.Select required value={details.vehicle_type}
      onChange={(event) => setDetails((previous) => ({ ...previous, vehicle_type: event.target.value }))}>
      <option value="">Select vehicle type</option>
      {["Car", "Dual Purpose", "Three Wheeler", "Motor Cycle", "Motor Coach"].map((vehicle) => (
        <option key={vehicle} value={vehicle}>{vehicle}</option>
      ))}
    </Form.Select>
  </FloatingLabel>
);

export const MotorMakeModel = ({ details, setDetails }) => (
  <>
    {[["make", "Make"], ["model", "Model"]].map(([field, label]) => (
      <FloatingLabel key={field} controlId={`motor-${field}`} label={`${label}*`}>
        <Form.Control type="text" placeholder={`${label}*`} required value={details[field]}
          onChange={(event) => setDetails((previous) => ({ ...previous, [field]: event.target.value }))} />
      </FloatingLabel>
    ))}
  </>
);
